module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./src/locales/ca-AD.json
// module id = 1461
// module chunks = 22